// extracted by mini-css-extract-plugin
export default {"test-2":"test2_test-2__6L6jZ","header":"test2_header__T+d8S","main-content":"test2_main-content__gWmQ0"};